var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"append-html",rawName:"v-append-html",value:(_vm.getContent),expression:"getContent"}],staticClass:"cms-content",attrs:{"data-id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }